import {
  Divider,
  Card,
  CardHeader,
  CardContent,
  Grid,
  Typography,
  Avatar,
  Tooltip,
  IconButton,
} from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import React, { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { Check, FileCopyOutlined } from "@mui/icons-material";
import copy from "copy-to-clipboard";
import { useGetWeightTransactionsExistenceQuery } from "src/_api/mapitShipApi";
import RedboxUnlockCodeSection from "./RedboxUnlockCodeSection";

// TODO: replace with the value coming from the backend once it is exposed.
const REDBOX_UNLOCK_CODE = "ADTPEIRD";
export default function ShippingCompanyDetailsCard({
  shipment,
  otoIntegration,
  title,
}) {
  const { t } = useTranslation();
  console.log(shipment);
  console.log(otoIntegration);

  const shipmentIds = useMemo(() => {
    const ids = [];
    if (otoIntegration?.shipment?.id) ids.push(otoIntegration.shipment.id);
    if (otoIntegration?.returnShipment?.id) ids.push(otoIntegration.returnShipment.id);
    return ids;
  }, [otoIntegration?.shipment?.id, otoIntegration?.returnShipment?.id]);

  const { data: weightTransactions } = useGetWeightTransactionsExistenceQuery(
    { shipmentIds },
    { skip: !shipmentIds.length }
  );

  const hasWeightTransactions = weightTransactions?.some(
    (item) => item.shipmentId === shipment?.id && item.hasWeightTransactions
  );

  // Helper to replace ShipmentNumber param in URL
  function replaceShipmentNumber(url, newShipmentNumber) {
    try {
      const u = new URL(url);
      u.searchParams.set("ShipmentNumber", newShipmentNumber);
      return u.toString();
    } catch {
      return url;
    }
  }

  const calculatedWeight =
    !!otoIntegration?.calculatedWeight &&
    Math.max(otoIntegration?.actualWeight, otoIntegration?.volumetricWeight) !==
      otoIntegration?.calculatedWeight;

  const [copiedValue, setCopiedValue] = useState(null);

  const handleCopy = (value) => {
    copy(value);
    setCopiedValue(value);
    setTimeout(() => {
      setCopiedValue(null);
    }, 2000);
  };

  return (
    <Card sx={{ mb: 2 }}>
      <CardHeader title={title} />
      <Divider />
      <CardContent>
        <Grid
          container
          justifyContent="space-between"
          alignItems="center"
          spacing={2}
          sx={{ mb: 2 }}
        >
          <Grid
            item
            md={6}
            sm={12}
            xs={12}
            sx={{ display: "flex", alignItems: "center" }}
          >
            <Avatar
              variant="rounded"
              src={shipment?.deliveryOption?.logo}
              sx={{ width: 56, height: 56 }}
            />
            <Typography sx={{ ml: 1.5 }} fontWeight="bold">
              {shipment?.deliveryOption?.deliveryOptionName}
            </Typography>
          </Grid>
          <Grid
            item
            md={6}
            sm={12}
            xs={12}
            sx={{ display: "flex", alignItems: "center" }}
          >
            <Typography
              sx={{ mr: 2 }}
              variant="h6"
              color="text.lighter"
              fontWeight="bold"
            >
              {t("Shipping cost")}
            </Typography>
            <Typography variant="h6" fontWeight="bold">
              {shipment?.deliveryOption?.price}
            </Typography>
          </Grid>
          <Grid
            item
            md={6}
            sm={12}
            xs={12}
            sx={{ display: "flex", alignItems: "center" }}
          >
            <Tooltip
              title={t(
                "It is the weight that is entered when creating the order.",
              )}
            >
              <IconButton size="small" aria-label="actual-weight-info">
                <InfoOutlinedIcon color="primary" fontSize="small" />
              </IconButton>
            </Tooltip>
            <Typography
              sx={{ mr: 1 }}
              variant="h6"
              color="text.lighter"
              fontWeight="bold"
            >
              {t("Actual weight")}
            </Typography>
            <Typography variant="h6" fontWeight="bold" sx={{ ml: 1 }}>
              {otoIntegration?.actualWeight}
            </Typography>
          </Grid>
          <Grid
            item
            md={6}
            sm={12}
            xs={12}
            sx={{ display: "flex", alignItems: "center" }}
          >
            <Tooltip
              title={t(
                "It is the weight calculated based on the dimensions of the order boxes.",
              )}
            >
              <IconButton size="small" aria-label="volumetric-weight-info">
                <InfoOutlinedIcon color="primary" fontSize="small" />
              </IconButton>
            </Tooltip>
            <Typography
              sx={{ mr: 1 }}
              variant="h6"
              color="text.lighter"
              fontWeight="bold"
            >
              {t("Volumetric weight")}
            </Typography>
            <Typography variant="h6" fontWeight="bold" sx={{ ml: 1 }}>
              {otoIntegration?.volumetricWeight}
            </Typography>
          </Grid>
          {calculatedWeight && (
            <Grid
              item
              md={6}
              sm={12}
              xs={12}
              sx={{ display: "flex", alignItems: "center" }}
            >
              <Typography
                sx={{ mr: 2 }}
                variant="h6"
                color="text.lighter"
                fontWeight="bold"
              >
                {t("Chargeable weight")}
              </Typography>
              <Typography variant="h6" fontWeight="bold">
                {otoIntegration?.calculatedWeight}
              </Typography>
            </Grid>
          )}
          {!!otoIntegration?.paymentMethod && (
            <Grid
              item
              md={6}
              sm={12}
              xs={12}
              sx={{ display: "flex", alignItems: "center" }}
            >
              <Typography
                sx={{ mr: 2 }}
                variant="h6"
                color="text.lighter"
                fontWeight="bold"
              >
                {t("Payment method")}
              </Typography>
              <Typography variant="h6" fontWeight="bold">
                {t(otoIntegration?.paymentMethod)}
              </Typography>
            </Grid>
          )}
          {!!shipment?.mainTrackingNumber &&
          shipment?.mainTrackingNumber !== shipment?.trackingNumber ? (
            <>
              <Grid
                item
                md={6}
                sm={12}
                xs={12}
                sx={{ display: "flex", alignItems: "center" }}
              >
                <Typography
                  sx={{ mr: 2 }}
                  variant="h6"
                  color="text.lighter"
                  fontWeight="bold"
                >
                  {t("Return shipment Number")}
                </Typography>
                <a
                  href={shipment?.trackingUrl}
                  target="_blank"
                  style={{ color: "inherit", textDecoration: "underline" }}
                >
                  <Typography variant="h6" fontWeight="bold" color="primary">
                    {shipment?.trackingNumber}
                  </Typography>
                </a>
              </Grid>

              <Grid
                item
                md={6}
                sm={12}
                xs={12}
                sx={{ display: "flex", alignItems: "center" }}
              >
                <Typography
                  sx={{ mr: 2 }}
                  variant="h6"
                  color="text.lighter"
                  fontWeight="bold"
                >
                  {t("Original Shipment Number")}
                </Typography>
                <a
                  href={replaceShipmentNumber(
                    shipment?.trackingUrl,
                    shipment?.mainTrackingNumber,
                  )}
                  target="_blank"
                  style={{ color: "inherit", textDecoration: "underline" }}
                >
                  <Typography variant="h6" fontWeight="bold" color="primary">
                    {shipment?.mainTrackingNumber}
                  </Typography>
                </a>
              </Grid>
            </>
          ) : (
            <Grid
              item
              md={6}
              sm={12}
              xs={12}
              sx={{ display: "flex", alignItems: "center" }}
            >
              <Typography
                sx={{ mr: 2 }}
                variant="h6"
                color="text.lighter"
                fontWeight="bold"
              >
                {t("Shipment Number")}
              </Typography>
              <a
                href={shipment?.trackingUrl}
                target="_blank"
                style={{ color: "inherit", textDecoration: "underline" }}
              >
                <Typography variant="h6" fontWeight="bold" color="primary">
                  {shipment?.trackingNumber}
                </Typography>
              </a>

              <Tooltip title={t("Copy")}>
                <IconButton
                  size="small"
                  onClick={() => handleCopy(shipment?.trackingNumber)}
                >
                  {copiedValue === shipment?.trackingNumber ? (
                    <Check fontSize="small" color="success" />
                  ) : (
                    <FileCopyOutlined fontSize="small" />
                  )}
                </IconButton>
              </Tooltip>
            </Grid>
          )}
          {shipment?.pickupRef && (
            <Grid
              item
              md={6}
              sm={12}
              xs={12}
              sx={{ display: "flex", alignItems: "center" }}
            >
              <Typography
                sx={{ mr: 2 }}
                variant="h6"
                color="text.lighter"
                fontWeight="bold"
              >
                {t("Pickup Referance")}
              </Typography>
              <Typography variant="h6" fontWeight="bold" color="black">
                {shipment?.pickupRef}
              </Typography>

              <Tooltip title={t("Copy")}>
                <IconButton
                  size="small"
                  onClick={() => handleCopy(shipment?.pickupRef)}
                >
                  {copiedValue === shipment?.pickupRef ? (
                    <Check fontSize="small" color="success" />
                  ) : (
                    <FileCopyOutlined fontSize="small" />
                  )}
                </IconButton>
              </Tooltip>
            </Grid>
          )}

          {shipment?.deliveryOption?.integrationType === "Redbox" && (
            <Grid item xs={12}>
              <RedboxUnlockCodeSection unlockCode={REDBOX_UNLOCK_CODE} />
            </Grid>
          )}
          {calculatedWeight && (
            <Grid item xs={12}>
              <Typography variant="body2" color="text.secondary">
                {t("updatedShipmentWeight", {
                  from: Math.max(
                    otoIntegration?.actualWeight,
                    otoIntegration?.volumetricWeight,
                  ),
                  to: otoIntegration?.calculatedWeight,
                })}
                {hasWeightTransactions && ` ${t("deliveryChargesAdjusted")}`}
              </Typography>
            </Grid>
          )}
        </Grid>
      </CardContent>
    </Card>
  );
}
